/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs */

const id_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini adalah tanggal pembuatan atau tanggal pembaruan terakhir.`)
};

const ms_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini adalah tarikh penciptaan atau tarikh kemas kini terakhir.`)
};

const da_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette er enten oprettelsesdatoen eller datoen for sidste opdatering.`)
};

const de_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dies ist entweder das Erstellungsdatum oder das Datum der letzten Aktualisierung.`)
};

const en_us2_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is either it's date of creation or the date of the last update.`)
};

const es_es2_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la fecha de creación o la fecha de la última actualización.`)
};

const es_mx2_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta es la fecha de creación o la fecha de la última actualización.`)
};

const fil_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ito ay alinman sa petsa ng paggawa nito o petsa ng huling update.`)
};

const fr_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il s'agit soit de sa date de création, soit de la date de la dernière mise à jour.`)
};

const it_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questa è la data di creazione o la data dell'ultimo aggiornamento.`)
};

const hu_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ez vagy a létrehozás dátuma, vagy az utolsó frissítés dátuma.`)
};

const nl_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dit is de aanmaakdatum of de datum van de laatste update.`)
};

const no_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dette er enten opprettelsesdatoen eller datoen for siste oppdatering.`)
};

const pl_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jest to data utworzenia lub data ostatniej aktualizacji.`)
};

const pt_br2_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é a data de criação ou a data da última atualização.`)
};

const pt_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esta é a data de criação ou a data da última atualização.`)
};

const ro_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceasta este data creării sau data ultimei actualizări.`)
};

const fi_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tämä on joko sen luontipäivä tai viimeisimmän päivityksen päivä.`)
};

const sv_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detta är antingen dess skapelsedatum eller datumet för den senaste uppdateringen.`)
};

const vi_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đây là ngày tạo hoặc ngày cập nhật lần cuối.`)
};

const tr_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu, oluşturulma tarihi veya son güncelleme tarihidir.`)
};

const cs_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toto je datum vytvoření nebo datum poslední aktualizace.`)
};

const bg_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Това е датата на създаване или датата на последната актуализация.`)
};

const ru_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это дата создания или дата последнего обновления.`)
};

const uk_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Це дата його створення або дата останнього оновлення.`)
};

const ar_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`هذا إما تاريخ الإنشاء أو تاريخ آخر تحديث.`)
};

const hi_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`यह या तो इसकी निर्माण तिथि है या अंतिम अपडेट की तिथि है।`)
};

const th_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`นี่คือวันที่สร้างหรือวันที่อัปเดตล่าสุด`)
};

const ja_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`これは作成日または最終更新日のいずれかです。`)
};

const zh_cn2_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是创建日期或最后更新日期。`)
};

const zh_hant1_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`這是建立日期或最後更新日期。`)
};

const ko_offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {(inputs: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`생성 날짜 또는 마지막 업데이트 날짜입니다.`)
};

/**
* | output |
* | --- |
* | "This is either it's date of creation or the date of the last update." |
*
* @param {Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_achievements_lastupdatedtooltipdescription4 = /** @type {((inputs?: Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Achievements_Lastupdatedtooltipdescription4Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "ms") return ms_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "da") return da_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "de") return de_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "en-US") return en_us2_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "fil") return fil_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "fr") return fr_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "it") return it_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "hu") return hu_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "nl") return nl_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "no") return no_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "pl") return pl_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "pt") return pt_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "ro") return ro_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "fi") return fi_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "sv") return sv_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "vi") return vi_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "tr") return tr_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "cs") return cs_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "bg") return bg_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "ru") return ru_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "uk") return uk_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "ar") return ar_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "hi") return hi_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "th") return th_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "ja") return ja_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
	return ko_offerdetail_achievements_lastupdatedtooltipdescription4(inputs)
});
export { offerdetail_achievements_lastupdatedtooltipdescription4 as "offerDetail.achievements.lastUpdatedTooltipDescription" }